export default {"src":"/_next/static/image/public/images/ic_document_green.f0742ee3ae371799f766c98925388ec5.svg","height":24,"width":19};